import React from 'react';
import Icon from '../../../components/AppIcon';
import { sanitizeResponsibilities } from '../../job-posting/utils';

const JobRequirements = ({ job }) => {
  return (
    <div className="bg-surface rounded-lg border border-border p-6">
      <h2 className="text-xl font-bold text-text-primary mb-4 flex items-center">
        <Icon name="CheckSquare" size={20} className="text-primary mr-2" />
        Requirements & Skills
      </h2>

      <div className="space-y-6">
        {/* Key Responsibilities */}
        {(() => {
          const clean = sanitizeResponsibilities(job?.responsibilities || '');
          return clean && clean.length > 0 ? (
            <div>
              <h3 className="text-lg font-semibold text-text-primary mb-3 flex items-center">
                <Icon name="ListTodo" size={16} className="text-primary mr-2" />
                Key Responsibilities
              </h3>
              <div className="text-text-secondary whitespace-pre-wrap">{clean}</div>
            </div>
          ) : null;
        })()}

        {/* Requirements */}
        {job?.requirements && job.requirements.length > 0 && (
          <div>
            <h3 className="text-lg font-semibold text-text-primary mb-3">Requirements & Qualifications</h3>
            <ul className="space-y-2">
              {job.requirements.map((requirement, index) => (
                <li key={index} className="flex items-start">
                  <Icon name="Dot" size={16} className="text-text-muted mr-2 mt-1 flex-shrink-0" />
                  <span className="text-text-secondary">{requirement}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Required Skills */}
        {job?.skills_required && job.skills_required.length > 0 && (
          <div>
            <h3 className="text-lg font-semibold text-text-primary mb-3">Required Skills</h3>
            <div className="flex flex-wrap gap-2">
              {job.skills_required.map((skill, index) => (
                <span
                  key={index}
                  className="px-3 py-1 bg-primary-100 text-primary-700 text-sm rounded-full border border-primary-200"
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Preferred Skills */}
        {job?.preferred_skills && job.preferred_skills.length > 0 && (
          <div>
            <h3 className="text-lg font-semibold text-text-primary mb-3">Preferred Skills</h3>
            <div className="flex flex-wrap gap-2">
              {job.preferred_skills.map((skill, index) => (
                <span
                  key={index}
                  className="px-3 py-1 bg-secondary-100 text-text-secondary text-sm rounded-full border border-border"
                >
                  {skill}
                </span>
              ))}
            </div>
          </div>
        )}

        {/* Job Details */}
        {(job?.application_deadline || job?.slots_available) && (
          <div className="bg-secondary-50 rounded-lg p-4">
            <h3 className="text-lg font-semibold text-text-primary mb-3">Job Details</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* {job?.slots_available && (
                <div className="flex items-center">
                  <Icon name="Users" size={16} className="text-text-muted mr-2" />
                  <span className="text-sm text-text-secondary">
                    {job.slots_available} position{job.slots_available > 1 ? 's' : ''} available
                  </span>
                </div>
              )} */}
              
              {job?.application_deadline && (
                <div className="flex items-center">
                  <Icon name="Calendar" size={16} className="text-text-muted mr-2" />
                  <span className="text-sm text-text-secondary">
                    Apply by {new Date(job.application_deadline).toLocaleDateString()}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default JobRequirements;
